(function () {


    const SelectorsDictionary = {
        ReviewPage: 'app-review-page',
        StandaloneOptionsBtn: 'button#standaloneOptions',
        AddToCartBtn: 'app-review-page div.hpe-config-list__button',
        EditCustomizationsBtn: 'div.edit-customizations-button button',
        ConfigButtonDesign: 'div.configuration-button-design'
    };

    const BODY_CLASS = 'fe-hpe-4062';

    /**
     * Swaps the Standalone Options button with Edit Customizations button
     * on the configurator review page
     */
    function swapButtons() {
        const reviewPage = document.querySelector(SelectorsDictionary.ReviewPage);
        if (!reviewPage) return;

        const standaloneBtn = reviewPage.querySelector(SelectorsDictionary.StandaloneOptionsBtn);
        const editCustomizationsBtn = reviewPage.querySelector(SelectorsDictionary.EditCustomizationsBtn);
        const configButtonContainer = reviewPage.querySelector(SelectorsDictionary.ConfigButtonDesign);
        const addToCartButtonContainer = reviewPage.querySelector(SelectorsDictionary.AddToCartBtn);

        if (!editCustomizationsBtn || !configButtonContainer) return;

        // Check if we already processed this review page
        if (configButtonContainer.classList.contains('fe-4062-processed')) return;

        // Mark as processed
        configButtonContainer.classList.add('fe-4062-processed');

        // Hide the Standalone Options button
        if (standaloneBtn)
            standaloneBtn.classList.add('fe-4062-hidden');

        // Clone the Edit Customizations button
        const clonedEditBtn = editCustomizationsBtn.cloneNode(true);
        clonedEditBtn.classList.add('fe-4062-edit-btn');

        // Copy click handler by triggering click on original button
        clonedEditBtn.addEventListener('click', function (e) {
            e.preventDefault();
            editCustomizationsBtn.click();
        });

        // Insert the cloned button where Standalone Options was, or before Add to Cart
        if (standaloneBtn)
            standaloneBtn.parentNode.insertBefore(clonedEditBtn, standaloneBtn);
        else if (addToCartButtonContainer)
            addToCartButtonContainer.parentNode.insertBefore(clonedEditBtn, addToCartButtonContainer);

        // Hide the original Edit Customizations button container
        const originalEditContainer = reviewPage.querySelector('div.edit-customizations-button');
        if (originalEditContainer) {
            originalEditContainer.classList.add('fe-4062-hidden');
        }

        window.feHPEB2C?.log(feProjectId + ': Swapped Standalone Options with Edit Customizations button');
    }

    /**
     * Sets up MutationObserver to watch for the review page appearing
     */
    function setupObserver() {
        const observer = new MutationObserver(function (mutations) {
            const reviewPage = document.querySelector(SelectorsDictionary.ReviewPage);
            if (reviewPage) {
                window.feHPEB2C?.log(feProjectId + ':reviewPage');
                swapButtons();
            }
        });

        // Observe the body for changes in the configurator
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        // Also try immediately in case review page already exists
        swapButtons();
    }

    function init() {
        try {
            document.body.classList.add(BODY_CLASS);
            setupObserver();
            window.feHPEB2C?.log(feProjectId + ': Initialized');
        } catch (error) {
            window.feHPEB2C?.log(feProjectId + ': Error - ' + error.message);
        }
    }

    window.feUtils.waitForConditions({
        conditions: ['body', () => {
            return window['FEi18n']?.isReady()
        }],
        activity: feProjectId,
        callback: init,
    })

})();
